import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import App from './App.tsx'
import { AppUiI18nProvider } from './i18n/AppUiI18nProvider'
import './index.css'
import '@fontsource/cormorant-garamond/latin.css'
import '@fontsource/cormorant-garamond/latin-ext.css'
import { releaseStuckModalOverlays } from '@/lib/modalOverlayCleanup'
import ToastNotificationBridge from '@/components/notifications/ToastNotificationBridge'
import ScrollToTop from '@/components/layout/ScrollToTop'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    releaseStuckModalOverlays()
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScrollToTop />
        <AppUiI18nProvider>
          <App />
        </AppUiI18nProvider>
        <ToastNotificationBridge />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              style: {
                background: '#10b981',
              },
            },
            error: {
              className: 'oms-toast-error',
              style: {
                background: '#ef4444',
              },
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
